import { PageContainer } from '@ant-design/pro-components'
import { createFileRoute, Link } from '@tanstack/react-router'
import { Tooltip } from 'antd'
import { DEFAULT_BILL_SEARCH, financeSearchSchema, MoneyLedger, type FinanceListSearch } from '@/features/bill/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence(
  'super-mega:finance:money:list-query',
  financeSearchSchema.omit({ month: true })
)

export const Route = createFileRoute('/_authenticated/finance/money')({
  beforeLoad: listQuery.restore,
  validateSearch: listQuery.validateSearch,
  component: MoneyPage
})

function MoneyPage() {
  const { currentSession } = Route.useRouteContext()
  const navigate = Route.useNavigate()
  const { search } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate
  })
  const canManage =
    currentSession.isSuperAdmin ||
    currentSession.permissions.some((permission) => permission.startsWith('bill.') && !permission.endsWith('.read'))
  const setSearch = (next: FinanceListSearch) => {
    void navigate({ search: next })
  }
  return (
    <PageContainer
      title="资金流水"
      content={
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span>查询实际收付款、退款及分配，核对到账时间和回单。</span>
          <Tooltip
            title="勾选同主体、同结算对象的账单后登记合并收付款；退款请在账单详情中选择原分配。"
            trigger={['hover', 'focus']}
          >
            <Link to="/finance/bills" search={DEFAULT_BILL_SEARCH} className="whitespace-nowrap">
              前往账单登记
            </Link>
          </Tooltip>
        </div>
      }
      breadcrumbRender={false}
    >
      <MoneyLedger search={search} setSearch={setSearch} canManage={canManage} />
    </PageContainer>
  )
}
